/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';
import { LocoNote } from './../../../shared/model/loco-note.model';
import { Tab } from './../../../core/model/tab.model';

/**
 * @export
 * @class LmsLocoNotesComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 * @implements {OnDestroyf}
 */
@Component({
  selector: 'lms-loco-data-notes',
  templateUrl: './lms-loco-data-notes.component.html',
  styleUrls: ['./lms-loco-data-notes.component.scss']
})
export class LmsLocoDataNotesComponent implements OnInit, OnChanges, OnDestroy {

  @Input() note: LocoNote;
  @Input() id: number;
  @Input() shownList: number;
  @Input() group: any;
  locoNotesForm: UntypedFormGroup;
  @Input() tab: Tab;
  deleteNoteClass: string;
  buttonLabel: string;


/**
   * Creates an instance of LmsLocoDataNotesComponent.
   *
   * @memberOf LmsLocoDataNotesComponent
   */
  constructor() {
  }

  /**
   * @memberOf LmsLocoDataNotesComponent
   */
  ngOnInit() {
    this.buttonLabel = 'Delete';
  }

  /**
   * @memberOf LmsLocoDataNotesComponent
   */
  ngOnDestroy() {
  }

  /**
    * Modify list of notes when component changes
    * @memberOf LmsLocoNotesComponent
    */
  ngOnChanges() {
    if (this.tab.mode === 'edit') {
      this.locoNotesForm = this.group;
    }
  }

  deleteCancelNoteData() {
    if ('Delete' === this.buttonLabel) {
      this.deleteNoteClass = 'deleted-notes';
      this.note.isDeleted = 'Y';
      this.buttonLabel = 'Cancel';
    } else {
      this.deleteNoteClass = '';
      this.note.isDeleted = 'N';
      this.buttonLabel = 'Delete';
    }

  }

  updateSearchText(event) {
    if (event && (this.locoNotesForm.controls.noteText.value !== event.toUpperCase())) {
      this.locoNotesForm.controls.noteText.setValue(event ? event.toUpperCase() : '');
    }
  }

}
